<template>
  <v-chip-group
    class="cfs-chip-group"
    active-class="white--text light-blue"
    :value="value"
    v-bind="$attrs"
    show-arrows
    mobile-breakpoint="xs"
    @change="$emit('change', $event)"
    v-on="$listeners"
  >
    <v-chip
      v-for="(tag, index) in tags"
      :key="index"
      :value="tag.value"
      class="cfs-chip-group__chip px-4 py-2"
    >
      {{ tag.title }}
    </v-chip>
  </v-chip-group>
</template>

<script lang="ts">
import { PropType } from 'vue';
import { BaseItemOption } from '@/types/common';

export default {
  name: 'CfsChipGroup',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    tags: {
      type: Array as PropType<BaseItemOption[]>,
      required: true,
      default: () => [],
    },
  },
};
</script>
